/* lua.js generated code 0.3.0 */

var dc = xClass("DCBase")
function getMap(tb) {
    tb = tb || table()
    var str = ""
    for (var k in tb) {
        var v = tb[k]
        str = str + k + ":" + v + ", "
    }
    return str
}

function sendDcLog(params, useSchema) {
    sendDcLogSingle(params, useSchema);
    // sendDcLogPending(params);
}

/**
 * 发送单条打点数据
 * @param params 
 */
function sendDcLogSingle(params, useSchema) {
    // var img = new Image();
    // img.src = DC_HOST + "?" + concatParams(params);
    sendDCLogSync(params, useSchema)
}

var pendingList = [];

/**
 * 直接向list中添加打点数据，不区分_uniq_key和_user_id，list中数量超过一定数量打包发送
 * @param params 
 */
function sendDcLogPending(params) {
    pendingList.push(params);

    if (pendingList.length >= 3) {
        var img = new Image();
        var dcUrl = DC_HOST + "?" + "_batch_value=" + JSON.stringify(pendingList);
        img.src = dcUrl;
        cc.log("dc:send", dcUrl);
        pendingList = [];

    } else {
        cc.log("dc:pending", "count: " + pendingList.length);
    }
}

/**
 * 以_uniq_key和_user_id为一个list项，在list项中添加打点数据，每个list项数量超过一定熟练打包发送
 * @param params 
 */
function sendDcLogPendingByUserAndKey(params) {
    var userId = params._user_id;
    var uniqKey = params._uniq_key;

    var findedValue = undefined;
    for (var i in pendingList) {
        var batchValue = pendingList[i];
        if (batchValue._user_id == userId && batchValue._uniq_key == uniqKey) {
            findedValue = batchValue;
            break;
        }
    }

    if (!findedValue) {
        findedValue = [];
        findedValue._user_id = userId;
        findedValue._uniq_key = uniqKey;
        findedValue._batch_value = [];
        pendingList.push(findedValue);
    }

    delete params._user_id;
    delete params._uniq_key;

    findedValue._batch_value.push(params);

    if (findedValue._batch_value.length > 3) {
        var img = new Image();
        var dcUrl = DC_HOST + "?" + "_uniq_key=" + uniqKey
            + "&_user_id=" + userId + "&_batch_value=" + JSON.stringify(findedValue._batch_value);
        img.src = dcUrl;

        cc.log("dc:send", dcUrl);
        findedValue._batch_value = [];
    } else {
        cc.log("dc:pending", "count: " + findedValue._batch_value.length);
    }
}

/**
 * 生成打点的基本数据map
 * @param acType 打点类型编号 
 */
function buildBaseMap(acType) {
    let now = new Date();
    return {
        _ac_type: acType,
        udid: b64Encode(UserManager.getInstance().uid),
        level:  UserManager.getInstance().user.topLevelId,
        time: formatDate(now),
        time_zone: -now.getTimezoneOffset() / 60
    }
}

/**
 * 将map中的KV使用&连接，作为url的查询字符串发送给服务器
 * @param map 
 */
function concatParams(map) {
    var arr = [];
    for (var name in map) {
        var value = map[name]
        arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }
    return arr.join("&");
}

let dcInstance = null
dc.getInstance = function () {
    if (!dcInstance) {
        dcInstance = dc.create()
    }
    return dcInstance
}
/*  * 打1号点，即：打DNU点，记录每日注册并首次登陆的用户信息
 * @param params 	table 	自定义扩展参数
 */
dc.prototype.dcNewUser_1 = function (param) {
    var self = this
    cc.log("dc:dcNewUser_1:", getMap(param))
}
/*  * 活跃用户
 * @param level 	number	
 * @param params 	table 	自定义扩展参数
 */
dc.prototype.dcActiveUser_2 = function (level, param) {
    var self = this
    cc.log("dc:dcActiveUser_2:", level, getMap(param))
}
//新手引导完成
dc.prototype.dcTutorial_3 = function () {
    var self = this
    // cc.log("dc:dcTutorial_3:")

    var params = buildBaseMap(3);
    sendDcLog(params);
    cc.log("dc:dcTutorial_3:", params);
}
/*  * 用户升级/经验值打点
 * @param lv1 		number 	用户升级前级别
 * @param lv1Exp 	number	用户升级前的经验值
 * @param lv2 		number 	用户升级后的级别
 * @param lv2Exp 	number	用户升级后的经验值
 * @param source 	string	用户获得经验的来源途径：比如杀怪时记录的怪物ID，完成任务时记录任务ID
 * @param dateTime 	string	用户升级或者经验发生改变时的时间
 * @param moudle 	string	用于区分何种升级？ 比如：平时的经验等级：level：声望等级：honour_level; vip等级：vip_level 等
 */
dc.prototype.dcLevelUp_4 = function (lv1, lv1Exp, lv2, lv2Exp, source, dateTime, module) {
    var self = this
    cc.log("dc:dcLevelUp_4:", lv1, lv1Exp, lv2, lv2Exp, source, dateTime, module)
}
/*  * 游戏加载
 * @param viralId 	string	唯一标识
 * @param step 		number	每部加载的步骤序号。完成第一步加载记录10；完成第2步加载记录20；以此类推。。。，以200结束。且记得一定是10，20，30，40这样的整数型往上写
 * @param isNew 	bool 	是否为新用户
 * @param interval 	number	从初始化到当前步骤的时间。单位毫秒
 */
dc.prototype.dcGameLoading_5 = function (viral_id, step, is_new, interval) {
    var self = this

    var params = buildBaseMap(5);
    params.viral_id = viral_id;
    // params.install_key = "";
    params.step = step;
    if (interval == undefined) {
        interval = is_new;
    } else {
        params.is_new = is_new;
    }
    params.interval = interval;
    params.is_new_device = META.is_new_device;
    sendDcLog(params);
    cc.log("dc:dcGameLoading_5:", params)

}
/*  * 保存用户状态
 * @param isNew 			bool	使用某一角色首次登陆某区服时打上true，其他情况下打false来标示
 * @param vipLevel 			number	用户的vip等级，非vip用户记为0
 * @param gameCoin 			number	用户游戏币数量（如有多种货币，可自行增加字段，例如game_coin1、game_coin2等，添加到attachStatus中）
 * @param happyCoin 		number	用户风车币数量
 * @param level 			number	用户等级
 * @param friendship 		number	友情值
 * @param energy 			number	精力值（各个游戏可能不同）
 * @param exp 				number 	用户经验值
 * @param friendNum 		number	每日登陆时当前好友数量
 * @param friendActiveNum	number	每日登陆时用户活跃好友数量（7天内登陆过的好友）
 * @param loginNum 			number	连续登陆天数
 * @param totalNum 			number	总活跃天数（活跃天数）
 * @param currentStage 		number	用户所在当前关卡
 * @param highStage
 * @param params 			table	自定义扩展参数
 */
dc.prototype.dcUserStatus_9 = function (isNew, vipLevel, gameCoin, happyCoin, level, friendship, energy, exp, friendNum, friendActiveNum, loginNum, totalNum, currentStage, highStage, attachStatus, stars, useSchema) {
    var self = this
    // cc.log("dc:dcUserStatus_9:", isNew, vipLevel, gameCoin, happyCoin, level, friendship, energy, exp, friendNum, friendActiveNum, loginNum, totalNum, currentStage, highStage, getMap(attachStatus))

    var params = buildBaseMap(9);
    params.sns_id = '';
    params.is_new = isNew;
    params.vip_level = vipLevel;
    params.game_coin = gameCoin;
    params.happy_coin = happyCoin;
    params.level = level;
    params.friendship = friendship;
    params.energy = energy;
    params.exp = exp;
    params.lang = "zh_CN";
    params.friend_num = friendNum;
    params.friend_active_num = friendActiveNum;
    params.login_num = loginNum;
    params.total_num = totalNum;
    params.current_stage = currentStage;
    params.high_stage = highStage;
    params.stars = stars;
    if (attachStatus.extractmap){
        params.extractmap = attachStatus.extractmap;
    }
    params.totalpay = attachStatus.totalpay || 0 // 历史累计付费（元）
    params.item_10001 = attachStatus.item_10001 || 0 // 当前永久刷新道具存量
    params.item_10002 = attachStatus.item_10002 || 0 // 当前永久冲浪板存量
    params.item_10003 = attachStatus.item_10003 || 0 // 当前永久强制交换存量
    params.item_10004 = attachStatus.item_10004 || 0 // 当前永久加5步存量
    params.item_10005 = attachStatus.item_10005 || 0 // 当前永久爆炸熊存量
    params.item_10006 = attachStatus.item_10006 || 0 // 当前永久小木锤存量
    // 其他反应玩家状态的字段

    sendDcLog(params, useSchema);
    cc.log("dc:dcUserStatus_9 todo sns_id lang:", params);
}
/*  * 游戏更新
 * @param guCategory 		number	0：开始更新 1：更新完成
 * @param gameversion1 		string	更新前的游戏版本
 * @param gameversion2 		string	更新后的游戏版本
 * @param interval 			number	更新过程所花的时间。单位毫秒
 */
dc.prototype.dcGameUpdate_12 = function (guCategory, gameversion1, gameversion2, interval) {
    var self = this
    cc.log("dc:dcGameUpdate_12:", guCategory, gameversion1, gameversion2, interval)
}
/*  * 点击广告
 */
dc.prototype.dc_adClick_13 = function () {
    var self = this
    cc.log("dc:dc_adClick_13:")
}

/*  * 新手引导每步打点
 * @param step 		number	用户刚刚完成该步引导
 */
dc.prototype.dcStepOfTutorial_15 = function (step, skip) {
    var self = this

    var params = buildBaseMap(15)
    params["step"] = step
    params["is_new"] = _G.kIsNewUser
    if (skip) {
        params["skip"] = true
    }
    sendDcLog(params);
    cc.log("dc:dcStepOfTutorial_15:", params)
}
/*  * @abstract 记录用户所有币种消费行为
 * @param activityId 		string	活动id
 * @param category 			string 	物品类型，比如升级装备、购买宝石。可自由定义
 * @param itemId 			string 	物品ID
 * @param itemName 			string	物品名称
 * @param cost 				number	物品单价
 * @param revenueCost 		number	物品打折后单价
 * @param num 				number	购买数量（若为动作，无数量 则打1）
 * @param coin1 			number	操作前玩家货币量
 * @param coin2 			number	操作后玩家货币量
 * @param currency 			string	货币种类：金币（game coins），精力（energy），风车币（happy coins） 等，（不允许使用汉字）
 * @param mainAccount 		number	消费的正账号钱
 * @param secondAccount 	number	消费的副账号钱
 * @param level 			number	用户购买时的级别
 * @param currentStage 		number	用户购买时的管卡
 * @param highStage 		number	用户购买时所处的管卡
 * @param stageMode 		number	0：普通管卡，1：pvp管卡，2：好友pvp，3：pve管卡等，以此类推
 * @param params 			table 	自定义扩展参数
 */
dc.prototype.dcCoinConsume_71 = function (activity_id, category, itemId, itemName, cost, revenueCost, num, coin1, coin2, currency, mainAccount, secondAccount, level, currentStage, highStage, stageMode, session, attachStatus) {
    var self = this
    // cc.log("dc:dcCoinConsume_71:", activity_id, category, itemId, itemName, cost, revenueCost, num, coin1, coin2, currency, mainAccount, secondAccount, level, currentStage, highStage, stageMode, getMap(attachStatus))

    var params = buildBaseMap(71);
    params.activity_id = activity_id;
    params.category = category;
    params.item_id = itemId;
    params.item_name = itemName;
    params.cost = cost;
    params.revenue_cost = revenueCost;
    params.num = num;
    params.coin1 = coin1;
    params.coin2 = coin2;
    params.currency = currency;
    params.main_account = mainAccount;
    params.second_account = secondAccount;
    params.level = level;
    params.current_stage = currentStage;
    params.high_stage = highStage;
    params.stage_mode = stageMode;
    if (session)
        params.session = session;

    if (attachStatus) { 
        for (var key in attachStatus) {
            params[key] = attachStatus[key];
        }
    }
    if (params.trade_id == null)
        params.trade_id = "0"
        
    sendDcLog(params);
    cc.log("dc:dcCoinConsume_71:", params);
}
/*  * 币种获得打点
 * @param module 		string	币种获得模块：如kill-boss，宠物系统、鱼等。充值获得的风车>币也要作为一个模块记录。只要是人与人之间交易得到的货币统一打成trade
 * @param category 		string	卖掉的物品类型
 * @param itemId 		string	卖掉的物品ID
 * @param itemName		string	卖掉的物品名称
 * @param cost			number	卖掉的物品单价
 * @param num			number	获得的货币数量
 * @param coin1			number	操作前玩家货币量
 * @param coin2			number	操作后玩家货币量
 * @param currency		string 	货币种类：金币（game coins），精力（energy），风车币（happy coins）等 （不允许使用汉字）
 * @param level			number	用户获得该币时的用户级别
 * @param currentStage	number	用户获得该币时最所处的关卡
 * @param highStage		number	用户最高关卡
 * @param stageMode		number	0：普通关卡；1：pvp关卡；2：好友pvp；3：pve关卡等以此类推
 * @param params		table	自定义扩展参数
 */
dc.prototype.dcCoinGain_72 = function (module, category, itemId, itemName, cost, num, coin1, coin2, currency, level, currentStage, highStage, stageMode, session, attachStatus) {
    var self = this
    // cc.log("dc:dcCoinGain_72:", module, category, itemId, itemName, cost, num, coin1, coin2, currency, level, currentStage, highStage, stageMode, getMap(attachStatus))

    var params = buildBaseMap(72);
    params["module"] = module;
    params["category"] = category;
    params["item_id"] = itemId;
    params["item_name"] = itemName;
    params["cost"] = cost;
    params["num"] = num;
    params["coin1"] = coin1;
    params["coin2"] = coin2;
    params["currency"] = currency;
    params["level"] = level;
    params["current_stage"] = currentStage;
    params["high_stage"] = highStage;
    params["stage_mode"] = stageMode;
    if (session)
        params["session"] = session;

    for (var key in attachStatus) {
        params[key] = attachStatus[key];
    }
    if (params.trade_id == null)
        params.trade_id = "0"
        
    if (params.goods_id == null)
        params.goods_id = "0"
        
    sendDcLog(params);
    cc.log("dc:dcCoinGain_72:", params);
}
/*  * 用户退出打点
 * @param ts 		number	登陆时间
 * @param te 		number	退出时间
 * @param ti 		number	在线时长(单位秒)
 * @param params 	table	其他想记录字段(map类型的kv对)
 */
dc.prototype.dcUserLogout_81 = function (ts, te, ti, params) {
    var self = this
    cc.log("dc:dcUserLogout_81:", ts, te, ti, params)
}
/*  * 88代表消息到达时的打点
 * @param viralId 	string 	每条消息的独立id（必须唯一），如feca3a94-cdd2-471b-a69f-20c969d0c22e
 */
dc.prototype.dcReceiveNotification_88 = function (viralId) {
    var self = this
    cc.log("dc:dcReceiveNotification_88:", viralId)
}
/*  * 89代表消息被点击激活应用程序时的点
 * @param viralId 	string 	每条消息的独立id（必须唯一），如feca3a94-cdd2-471b-a69f-20c969d0c22e
 */
dc.prototype.dcOnclickNotification_89 = function (viralId) {
    var self = this
    cc.log("dc:dcOnclickNotification_89:", viralId)
}
/*  * 用户第一次闯关时打点
 * @param result 			number	第一次闯关的结果：失败（记为0）or 成功（记为1）
 * @param useItem 			number	是否使用道具：没使用道具（记为0）or 使用道具 （记为1）
 * @param level 			number	用户的级别（如果纯粹是关卡主线类游戏，则为用户的最高关卡）
 * @param currentStage 		number 	用户当前关卡
 * @param highStage 		number 	用户最高关卡
 * @param stageMode 		number 	用户所处的关卡类型：0：普通关卡；1：pvp关卡；2：好友pvp；3：pve关卡，以此类推
 * @param stageTime 		number 	从开始打该关卡到结束所需要的时间。单位：second
 */
dc.prototype.dcStageFirst_98 = function (result, use_item, level, current_stage, high_stage, stage_mode, stage_time) {
    var self = this
    cc.log("dc:dcStageFirst_98:", result, use_item, level, current_stage, high_stage, stage_mode, stage_time)
}
/*  * 用户第一次闯关时打点
 * @param result 			number	第一次闯关的结果：失败（记为0）or 成功（记为1）
 * @param useItem 			number	是否使用道具：没使用道具（记为0）or 使用道具 （记为1）
 * @param level 			number	用户的级别（如果纯粹是关卡主线类游戏，则为用户的最高关卡）
 * @param currentStage 		number 	用户当前关卡
 * @param highStage 		number 	用户最高关卡
 * @param stageMode 		number 	用户所处的关卡类型：0：普通关卡；1：pvp关卡；2：好友pvp；3：pve关卡，以此类推
 * @param stageTime 		number 	从开始打该关卡到结束所需要的时间。单位：second
 */
dc.prototype.dcStageFirst_99 = function (result, use_item, level, current_stage, high_stage, stage_mode, stage_time) {
    var self = this
    cc.log("dc:dcStageFirst_99:", result, use_item, level, current_stage, high_stage, stage_mode, stage_time)
}
/*  * 用户行为打点
 * @param category 		string 	行为类型。如病毒性、收入、扭蛋活动等
 * @param subCategory 	string 	详细行为。如喂鱼、购买等
 * @param params 		table 	自定义扩展参数
 */
dc.prototype.dcUserTrack_101 = function (category, sub_category, attachStatus) {
    var self = this
    // cc.log("dc:dcUserTrack_101:", category, sub_category, getMap(attachStatus))

    var params = buildBaseMap(101);
    params.category = category;
    params.stage_level = UserManager.getInstance().user.topLevelId// 当前用户打点时的等级
    params.sub_category = sub_category;
    params.level
    for (var key in attachStatus) {
        params[key] = attachStatus[key];
    }

    sendDcLog(params);
    cc.log("dc:dcUserTrack_101 todo:", params);
}
/*  * 物品获得打点
 * @param category 		string 	物品类型可自由定义
 * @param itemId 		string 	物品ID
 * @param itemName 		string 	物品名称
 * @param source 		string 	获得来源：购买、赠送、末日活动等游戏中哪种方式获得的记录【金钱购买的道具固定为buy_币种,人与人之间交易得到的物品统>一打成trade】 (其实17年的时候他们就没有遵循这条规则了，坑)
 * @param num 			number 	获得数量
 * @param level 		number 	物品获得时的用户级别
 * @param currentStage 	number	物品获得时用户所处的关卡
 * @param highStage 	number 	用户最高关卡
 * @param stageMode 	number 	0：普通关卡；1：pvp关卡；2：好友pvp；3：pve关卡等以此类推
 * @param params 		table 	自定义扩展参数
 */
dc.prototype.dcItemGain_102 = function (category, itemId, itemName, source, num, level, currentStage, highStage, stageMode, session, attachStatus) {
    var self = this
    // cc.log("dc:dcItemGain_102:", category, itemId, itemName, source, num, level, currentStage, highStage, stageMode, getMap(attachStatus))

    var params = buildBaseMap(102);
    params.category = category;
    params.item_id = itemId;
    params.item_name = itemName;
    params.source = source;
    params.num = num;
    params.level = level;
    params.current_stage = currentStage;
    params.high_stage = highStage;
    params.stage_mode = stageMode;

    if (session)
        params.session = session;
        
    for (var key in attachStatus) {
        params[key] = attachStatus[key];
    }

    if (params.trade_id == "null")
        params.trade_id = "0"

    sendDcLog(params);
    cc.log("dc:dcItemGain_102:", params);
}
/*  * 物品使用打点
 * @param category 		string 	物品类型可自由定义
 * @param itemId 		string 	物品ID
 * @param itemName 		string 	物品名称
 * @param use 			string 	物品如何被使用掉，比如兑换宝石等。。【人与人之间交易消耗的物品统一打成trade】
 * @param num 			number 	使用数量
 * @param level 		number 	物品使用时的用户级别
 * @param currentStage 	number	物品使用时用户所处的关卡
 * @param highStage 	number 	用户最高关卡
 * @param stageMode 	number 	0：普通关卡；1：pvp关卡；2：好友pvp；3：pve关卡等以此类推
 * @param params 		table 	自定义扩展参数
 */
dc.prototype.dcItemUse_103 = function (category, itemId, itemName, use, num, level, currentStage, highStage, stageMode, session, attachStatus) {
    var self = this
    // cc.log("dc:dcItemUse_103:", category, itemId, itemName, use, num, level, currentStage, highStage, stageMode, getMap(attachStatus))

    var params = buildBaseMap(103);
    params.category = category;
    params.item_id = itemId;
    params.item_name = itemName;
    params.use = use;
    params.num = num;
    params.lang = "zh_CN";
    params.level = level;
    params.current_stage = currentStage;
    params.high_stage = highStage;
    params.stage_mode = stageMode;

    for (var key in attachStatus) {
        params[key] = attachStatus[key];
    }

    if (session)
        params.session = session;

    sendDcLog(params);
    cc.log("dc:dcItemUse_103 todo lang:", params);
}

/**
 * 用户心跳打点
 */
dc.prototype.dcUserOnline_104 = function () {
    var self = this
    // cc.log("dc:dcUserOnline_104:", cum_time)

    var params = buildBaseMap(104);
    GameProxy.getInstance().getNetworkType(function (networktype) {
        if (networktype == 1) {
            params.networktype = "WiFi";
        } else if (networktype == 4) {
            params.networktype = "4G";
        } else if (networktype == 3) {
            params.networktype = "3G";
        } else if (networktype == 2) {
            params.networktype = "2G";
        } else if (networktype == 0) {
            params.networktype = "NotReachable";
        } else {
            params.networktype = "Unknown";
        }

        sendDcLog(params);
        cc.log("dc:dcUserOnline_104:", params);
    });
}
/*  * @abstract 记录用户活动、奖励领取和兑换行为
 * @param activityId   	string  活动ID
 * @param category 		string  click/reward/exchange之一（若有其它可增加，提前通知BI）
 * @param subCategory   string 	活动详细行为、详细兑换或领奖类别
 * @param itemId    	string 	兑换获得的货币ID或者物品ID（道具1id*道具2id*道具3id）
 * @param num 			number	兑换获得的数量（道具1数量*道具2数量*道具3数量
 * @param provideItemId string 	提供的道具ID（道具1id*道具2id*道具3id）
 * @param provideNum   	number	提供道具的数量（道具1数量*道具2数量*道具3数量）
 * @param level 		number 	玩家等级
 * @param params 		table 	自定义扩展参数
 */
dc.prototype.dcActivity_110 = function (activity_id, category, sub_category, item_id, num, provide_itemid, provide_num, level, attachStatus) {
    var self = this
    cc.log("dc:dcActivity_110:", activity_id, category, sub_category, item_id, num, provide_itemid, provide_num, level, getMap(attachStatus))
}
dc.prototype.dcCustom = function (ac_type, attachStatus) {
    var self = this
    var params = buildBaseMap(ac_type);
    for (var key in attachStatus) {
        params[key] = attachStatus[key];
    }

    sendDcLog(params);
    cc.log("dc:dcCustom:", params);
}
/** 
 * @abstract    记录用户画像基础数据 
 * @param   keyt    string    用户手机号登录的号码，可以为空
 */
dc.prototype.dcUserPortrait_900 = function (dcData) {
    let systemInfo = mini.getSystemInfoSync()
    let params = buildBaseMap(900);

    params.gid = UserManager.getInstance().uid;                                 //  用户id
    params.name = dcData.name || ""                                             //  昵称
    params.sex = dcData.gender || "0"                                           //  性别
    params.country = dcData.country || ""                                       //  用户资料中的国家
    params.province = dcData.province || ""                                     //  用户资料中的省份
    params.city = dcData.city || ""                                             //  用户资料中的城市
    params.district = ""                                                        //  当前IP所在地
    params.isp = ""                                                             //  当前IP所在服务提供商
    params.friend_num = FriendManager.getInstance().getFriendCount()            //  游戏好友数
    params.carrier = ""                                                         //  运营商，感觉和isp其实是一样的
    params.clienttype = systemInfo.model                                        //  手机型号
    params.clientversion = systemInfo.version                                   //  微信版本号
    params.location = ""                                                        //  国家或地区，暂时打空

    sendDcLog(params);
    cc.log("dc:dcUserPortrait:", params);
}

/**
 * 新通用打点, 进UseractionUnknownCategory
 */
dc.prototype.dc2UseractionUnknownCategory = function (category, sub_category, attachStatus) {
    var self = this
    // cc.log("dc:dcUserTrack_101:", category, sub_category, getMap(attachStatus))

    var params = buildBaseMap("useraction_unknown_category");
    params.gameversion = META.version;
    params.category = category;
    params.stage_level = UserManager.getInstance().user.topLevelId// 当前用户打点时的等级
    params.sub_category = sub_category;
    params.level
    for (var key in attachStatus) {
        params[key] = attachStatus[key];
    }
    sendDcLog(params, true);
    cc.log("dc:dcUserdc2UseractionUnknownCategory", params);
}


/**
 * 2020-06打点优化迭代
 * 现金商品相关，进useraction_payment
 * https://docs.google.com/spreadsheets/d/1ZWgRNLmqylhLbpSNZRL5HF5Ep1kNu802r_3ov9IS5TY/edit#gid=0
 */
dc.prototype.dcCashGoods = function (category, sub_category, attachStatus) {
    let params = buildBaseMap("useraction_payment");
    params.gameversion = META.version;
    params.category = category;
    params.sub_category = sub_category;
    Object.assign(params, attachStatus);
    sendDcLog(params, true);
    cc.log("dc:dcCashGoods", params);
}

/**
 * 2020-07打点优化迭代
 * 分享相关，进useraction_share
 * https://docs.google.com/spreadsheets/d/1lLFXdeD-EpYq7weZnRB0yh2YwpxRjhlq
 */
dc.prototype.dcShareAction = function (category, sub_category, attachStatus) {
    let params = buildBaseMap("useraction_share");
    params.gameversion = META.version;
    params.category = category;
    params.sub_category = sub_category;
    Object.assign(params, attachStatus);
    sendDcLog(params, true);
    cc.log("dc:dcShareAction", params);
}

/**
 * 广告互导
 */
dc.prototype.dcPromotionAction = function (category, sub_category, attachStatus) {
    let params = buildBaseMap("useraction_promotion");
    params.gameversion = META.version;
    params.category = category;
    params.sub_category = sub_category;
    Object.assign(params, attachStatus);
    sendDcLog(params, true);
    cc.log("dc:dcPromotionAction", params);
}


/**
 * 2020-11道具广告二期宝船功能
 */
dc.prototype.dcGoldTurn = function (category, sub_category, attachStatus) {
    let params = buildBaseMap("useraction_share_ad_pay");
    params.gameversion = META.version;
    params.category = category;
    params.sub_category = sub_category;
    Object.assign(params, attachStatus);
    sendDcLog(params, true);
    cc.log("dc:dcGoldTurn", params);
}

/**
 * 2020-11召回强化
 */
dc.prototype.dcReturnBack = function (category, sub_category, attachStatus) {
    let params = buildBaseMap("useraction_unknown_category");
    params.gameversion = META.version;
    params.category = category;
    params.sub_category = sub_category;
    Object.assign(params, attachStatus);
    sendDcLog(params, true);
    cc.log("dc:dcReturnBack", params);
}

dc.prototype.dcSpecialCharMapping = function (str) {
    let map = [",","|",":","'","[","]","{","}","&","?","%","\\","#","\"","\\n","\\r","\\f","\\001","\\002","\\003","\\t",";"]
    // ",":"specail_char_1",
    for (let i = 0; i < map.length; i++) {
        if (str == map[i]){
            // cc.log("dcSpecialCharMapping str ",str)
            return "specail_char_"+i
        }        
    }
    return str
}
module.exports = dc
